import { SVGProps } from 'react';

export const FilterIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        {...props}
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
        focusable="false"
    >
        <path
            d="M4.5 5.5h11l-4.4 5.6v3.4l-2.2 1.4v-4.8L4.5 5.5Z"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinejoin="round"
        />
    </svg>
);

export default FilterIcon;
